import { deleteRequest, getRequest } from '../../../services/base'
import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'
import { createSearchParams, useParams } from 'react-router-dom'
import { GraphMissingImagesContext } from './context/context'
import InputText from '../../common/InputText'
import Button from '../../common/Button'
import Select from 'react-select'
import { downloadFileBlob, toTitleCase } from '../../../utils/common'
import GraphMissingImagesRow from './GraphMissingImagesRow'
import DtcValidationButton from '../../DtcValidationButton'
import CheckBox from '../../common/CheckBox'
import LinkWithStatus from '../../common/LinkWithStatus'
import { getSessionStorageData } from '../../../utils/SessionStorage'

const GraphMissingImages = (props) => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(NavContext)
  const [graphMissingImagesState, graphMissingImagesDisptach] = useContext(
    GraphMissingImagesContext
  )
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  const [selectedVersions, setSelectedVersions] = useState([])
  const [versionOptions, setVersionOptions] = useState([])
  const [showFilters, setShowFilters] = useState(false)
  const [isMissingConnectorOrTerminalImg, setIsMissingConnectorOrTerminalImg] =
    useState(0)
  const [isMissingVehicleImg, setIsMissingVehicleImg] = useState(0)
  const [vinOptions, setVinOptions] = useState([])
  const [selectedvin, setSelectedVin] = useState([])

  const [categoryOptions, setCategoryOptions] = useState([])
  const [selectedCategory, setSelectedCategory] = useState([])

  const [progressMessage, setProgressMessage] = useState()

  const currentUrl = useRef(`/api/graph_missing_images/?vehicle=${vehicle}`)

  useEffect(() => {
    getGraphMissingImageList(null)
    getGraphMissingImageVersions()
    getGraphMissingImageVins()
    getGraphMissingImageCategory()

    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Graph Missing Images`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  const getGraphMissingImageList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Missing Graph Images Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(currentUrl.current)
    graphMissingImagesDisptach({
      type: 'set_graph_missing_images_data',
      data: response.results,
    })
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const getGraphMissingImageVersions = async () => {
    let response = await getRequest(
      `/api/graph_missing_images/versions/?vehicle=${vehicle}`
    )
    setVersionOptions(response.data)
  }

  const getGraphMissingImageVins = async () => {
    let response = await getRequest(
      `/api/graph_missing_images/vin/?vehicle=${vehicle}`
    )
    setVinOptions(response.data)
  }

  const getGraphMissingImageCategory = async () => {
    let response = await getRequest(
      `/api/graph_missing_images/category/?vehicle=${vehicle}`
    )
    setCategoryOptions(response.data)
  }

  const deleteGraphMissingImage = async (selectedObj) => {
    if (
      window.confirm(
        `Are you sure want to delete ${selectedObj.component_id}`
      ) === true
    ) {
      let res = await deleteRequest(
        `/api/graph_missing_images/delete/${vehicle}/${selectedObj.id}/`
      )
      getGraphMissingImageList('')
    }
  }

  const downloadMissingImages = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: `Downloading Missing Images file is in progress.`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/graph_missing_images/export/?vehicle=${vehicle}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_missing_vehicle_img=${isMissingVehicleImg}&is_missing_connector_or_terminal_img=${isMissingConnectorOrTerminalImg}&category=${formatFilterUrl(selectedCategory)}&vin=${formatFilterUrl(selectedvin)}`,
      true,
      true
    )
    if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `missing_images-${vehicle}.csv`)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  const formatFilterUrl = (values) => {
    if (values) {
      let names = values?.map(function (item) {
        return item.value
      })
      return names.toString()
    } else {
      return ''
    }
  }

  return (
    <div className="w-full p-2">
      <form
        className="flex flex-col w-full space-y-2 pb-2 container m-auto"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          currentUrl.current = `/api/graph_missing_images/?vehicle=${vehicle}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_missing_vehicle_img=${isMissingVehicleImg}&is_missing_connector_or_terminal_img=${isMissingConnectorOrTerminalImg}&category=${formatFilterUrl(selectedCategory)}&vin=${formatFilterUrl(selectedvin)}`
          getGraphMissingImageList()
        }}
      >
        <div className="bg-tracer-dark-blue p-2 rounded px-4">
          <div className={`flex space-x-2 justify-between items-center w-full`}>
            <div className="flex space-x-2 items-center w-full">
              <div className="flex items-center w-full">
                <InputText
                  name="search_value"
                  placeholder={`Search Component Id, Description, Vin`}
                  className={`w-auto`}
                  value={searchValue}
                  isFullSize={true}
                  type="search"
                  onChange={(value) => {
                    setSearchValue(value)
                  }}
                  isRequired={false}
                  wrapperClass={`pl-0`}
                />
              </div>
              <Select
                classNamePrefix="dtcs-filter"
                isMulti={false}
                value={selectedVersions}
                options={versionOptions.map((val) => ({
                  value: val,
                  label: val,
                }))}
                placeholder="Select Tracer Data Version"
                className="w-full cursor-pointer"
                onChange={(value) => {
                  setSelectedVersions(value)
                }}
                isClearable={true}
              />

              <Select
                classNamePrefix="dtcs-filter"
                isMulti={true}
                value={selectedCategory}
                options={categoryOptions.map((val) => ({
                  value: val,
                  label: toTitleCase(val),
                }))}
                placeholder="Select Category"
                className="w-full cursor-pointer"
                onChange={(value) => {
                  setSelectedCategory(value)
                }}
                isClearable={true}
              />
              <Select
                classNamePrefix="dtcs-filter"
                isMulti={true}
                value={selectedvin}
                options={vinOptions.map((val) => ({
                  value: val,
                  label: val,
                }))}
                placeholder="Select Vin"
                className="w-full cursor-pointer"
                onChange={(value) => {
                  setSelectedVin(value)
                }}
                isClearable={true}
              />

              <Button
                className={`cursor-pointer btn my-4 justify-end`}
                text={`Search`}
                onClick={() => {}}
              />
            </div>
          </div>

          <div className="flex space-x-2 justify-between items-center">
            <div className="flex font-light text-center space-x-5 justify-end content-center items-center">
              <CheckBox
                checked={isMissingVehicleImg === 1 ? true : false}
                onChange={(e) => {
                  if (!e.target.checked) {
                    setIsMissingVehicleImg(0)
                    currentUrl.current = `/api/graph_missing_images/?vehicle=${vehicle}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_missing_vehicle_img=0&is_missing_connector_or_terminal_img=${isMissingConnectorOrTerminalImg}&category=${formatFilterUrl(selectedCategory)}&vin=${formatFilterUrl(selectedvin)}`
                  } else {
                    setIsMissingVehicleImg(1)
                    currentUrl.current = `/api/graph_missing_images/?vehicle=${vehicle}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_missing_vehicle_img=1&is_missing_connector_or_terminal_img=${isMissingConnectorOrTerminalImg}&category=${formatFilterUrl(selectedCategory)}&vin=${formatFilterUrl(selectedvin)}`
                  }
                  getGraphMissingImageList()
                }}
              />
              <span className="text-white">Is Missing Vehicle Images</span>
            </div>
            <div className="flex font-light text-center space-x-5 justify-end content-center items-center">
              <CheckBox
                checked={isMissingConnectorOrTerminalImg === 1 ? true : false}
                onChange={(e) => {
                  if (!e.target.checked) {
                    setIsMissingConnectorOrTerminalImg(0)
                    currentUrl.current = `/api/graph_missing_images/?vehicle=${vehicle}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_missing_vehicle_img=${isMissingVehicleImg}&is_missing_connector_or_terminal_img=0&category=${formatFilterUrl(selectedCategory)}&vin=${formatFilterUrl(selectedvin)}`
                  } else {
                    setIsMissingConnectorOrTerminalImg(1)
                    currentUrl.current = `/api/graph_missing_images/?vehicle=${vehicle}&search=${searchValue}&data_version=${selectedVersions?.value ? selectedVersions?.value : ''}&is_missing_vehicle_img=${isMissingVehicleImg}&is_missing_connector_or_terminal_img=1&category=${formatFilterUrl(selectedCategory)}&vin=${formatFilterUrl(selectedvin)}`
                  }
                  getGraphMissingImageList()
                }}
              />
              <span className="text-white">
                Is Missing Connector Or Terminal Images
              </span>
            </div>

            <div className="flex font-light text-center space-x-5 justify-end content-center items-center">
              <DtcValidationButton setProgressMessage={setProgressMessage} />
              <div className="flex justify-end">
                <LinkWithStatus
                  href={`/administration/graph_missing_images`}
                  className={`cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded `}
                  title={`Export Missing Images`}
                  onClickFunc={() => {
                    downloadMissingImages()
                  }}
                />
              </div>
            </div>
          </div>

          {progressMessage && (
            <div className="flex space-x-2 justify-center items-center py-1 text-sm text-red-700 text-center">
              {progressMessage}
            </div>
          )}
        </div>
      </form>

      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-2/12 pl-10 items-center">Component Id</div>
          <div className="flex w-3/12 pl-6 items-center">Description</div>
          <div className="flex w-2/12 pl-6 items-center">Harness</div>
          <div className="flex w-2/12 pl-6 items-center">Vin</div>
          <div className="flex w-1/12 pl-6 items-center">Category</div>
          <div className="flex w-3/12 pl-6 items-center">Missing Images</div>
        </div>
      </div>
      {graphMissingImagesState?.data?.map((graph_missing_images, index) => {
        return (
          <GraphMissingImagesRow
            {...graph_missing_images}
            key={`graph-missing-images-${index}`}
            onEdit={() => {
              graphMissingImagesDisptach({
                type: 'set_selected_graph_missing_images_data',
                data: { ...graph_missing_images, index: index },
              })
            }}
            onDelete={() => deleteGraphMissingImage(graph_missing_images)}
          />
        )
      })}
      {graphMissingImagesState?.data?.length < 1 && (
        <NoRecordsFound
          caption={'Graph Missing Images Not Found'}
          loading={false}
        />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            currentUrl.current = e
            getGraphMissingImageList(e)
          }}
          onClickPrev={(e) => {
            currentUrl.current = e
            getGraphMissingImageList(e)
          }}
        />
      </div>
    </div>
  )
}

export default GraphMissingImages
